import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'motion/react';
import alienXImage from '../assets/images/alien_x_8k_1785416801849.jpg';

export default function AlienXBackground() {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 1000], [0, 200]);
  const opacity = useTransform(scrollY, [0, 500], [1, 0.4]);

  const [particles, setParticles] = useState<{ id: number; x: number; y: number; size: number; duration: number; delay: number }[]>([]);

  useEffect(() => {
    // Generate random stars/particles for the cosmic effect
    const newParticles = Array.from({ length: 50 }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 3 + 1,
      duration: Math.random() * 20 + 10,
      delay: Math.random() * 5,
    }));
    setParticles(newParticles);
  }, []);

  return (
    <div className="fixed inset-0 z-[-1] overflow-hidden bg-black flex items-center justify-center">
      {/* 
        User's Photo as a "Live Video" Background 
        We use motion to slowly scale and pan it, giving it a breathing, live feel.
      */}
      <motion.div
        className="absolute inset-0"
        style={{ y, opacity }}
        animate={{
          scale: [1, 1.05, 1],
          rotate: [0, 0.5, -0.5, 0],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <div 
          className="w-full h-full bg-center bg-cover opacity-50"
          style={{ 
            backgroundImage: `url(${alienXImage})` 
          }}
        />
        {/* Deep space gradient overlay to blend it with the website */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,black_100%)]" />
      </motion.div>

      {/* Optimized Floating Particles (Stars/Cosmic Dust) */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {particles.slice(0, 20).map((p) => (
          <div
            key={p.id}
            className="absolute rounded-full bg-white shadow-[0_0_8px_#22c55e] animate-pulse"
            style={{
              left: `${p.x}%`,
              top: `${p.y}%`,
              width: `${p.size}px`,
              height: `${p.size}px`,
              opacity: 0.6,
            }}
          />
        ))}
      </div>

      {/* Deep voice text effect */}
      <motion.div 
        className="absolute z-10 text-center pointer-events-none"
        initial={{ opacity: 0, scale: 0.8, filter: "blur(10px)" }}
        animate={{ opacity: 0.8, scale: 1, filter: "blur(0px)" }}
        transition={{ duration: 4, delay: 1, ease: "easeOut" }}
      >
        <motion.h1 
          className="text-4xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-b from-green-300 to-green-800 tracking-widest uppercase drop-shadow-[0_0_15px_rgba(34,197,94,0.5)]"
          animate={{ 
            textShadow: ["0px 0px 10px #22c55e", "0px 0px 30px #22c55e", "0px 0px 10px #22c55e"]
          }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        >
          Welcome to
          <br/>
          Alien X Factory
        </motion.h1>
      </motion.div>
    </div>
  );
}
